import { render, staticRenderFns } from "./FileTypeDialog.vue?vue&type=template&id=c48aef46&scoped=true"
import script from "./FileTypeDialog.vue?vue&type=script&lang=js"
export * from "./FileTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./FileTypeDialog.vue?vue&type=style&index=0&id=c48aef46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.8__ejs@3.1.10_loda_tabtodhn2upniikejzvtfgbz5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48aef46",
  null
  
)

export default component.exports